export default __webpack_public_path__ + "static/media/action-plan.75e73ff0.svg";